import { Button, CloseButton, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import FilterList from '@/assets/icons/ic-filter-list.svg';

import { EventsFilter } from '@/components/ui/features/ hubs-conferences/EventsFilter/EventsFilter';
import { useHubsLibraryFilters } from '@/components/ui/features/hubs-conference/LibraryFilter/HubsLibraryFilter.hooks';

export const EventsFilterDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { reset } = useHubsLibraryFilters();

  return (
    <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent p={{ base: 5, md: 10 }}>
        <Flex mb={{ base: 5, md: 10 }} alignItems="center" justifyContent="space-between">
          <Button variant="unstyled" rightIcon={<FilterList color="#5B1CF4" />} onClick={reset}>
            {t('library.clearFilters')}
          </Button>
          <CloseButton onClick={onClose} />
        </Flex>

        <DrawerBody overflowY="hidden" p={0}>
          <EventsFilter />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
